import { useState, useEffect } from "react";
import { ShoppingCart, ArrowLeft } from "lucide-react";
import { Toaster } from "sonner";
import ReactMarkdown from "react-markdown";

const API = process.env.REACT_APP_BACKEND_URL;

const LegalPage = ({ type }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  const title = type === "terms" ? "Terms of Service" : "Privacy Policy";

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${API}/api/${type}`);
        const data = await response.json();
        setContent(data.content || "Content not found.");
      } catch (error) {
        setContent("Failed to load content. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, [type]);

  return (
    <div className="min-h-screen bg-white">
      <Toaster position="top-center" />
      
      {/* Header */}
      <header className="bg-white border-b border-border p-6 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto">
          <a href="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary mb-4">
            <ArrowLeft className="w-4 h-4" />
            Back to App
          </a>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center">
              <ShoppingCart className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="font-syne text-2xl font-bold text-primary">
                PriceSlice
              </h1>
              <p className="text-muted-foreground text-sm">{title}</p>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto p-6">
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        ) : (
          <article className="prose prose-sm max-w-none prose-headings:font-syne prose-headings:text-primary prose-a:text-primary">
            <ReactMarkdown>{content}</ReactMarkdown>
          </article>
        )}

        {/* Footer */}
        <footer className="mt-12 pt-6 border-t border-border text-center">
          <p className="text-xs text-muted-foreground">
            © 2026 PriceSlice.uk · All rights reserved
          </p>
          <p className="text-xs text-muted-foreground mt-2">
            <a href="/terms" className="hover:underline">Terms of Service</a>
            {" · "}
            <a href="/privacy" className="hover:underline">Privacy Policy</a>
            {" · "}
            <a href="/contact" className="hover:underline">Contact</a>
          </p>
        </footer>
      </main>
    </div>
  );
};

export default LegalPage;
